import { render, staticRenderFns } from "./UserMyAddresses.vue?vue&type=template&id=62d555c8"
import script from "./UserMyAddresses.vue?vue&type=script&lang=js"
export * from "./UserMyAddresses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports